import { api, isLoggedIn } from '../api'
import { AppSchema } from '/common/types/schema'

export async function createFeedback(feedback: { title: string; content: string }) {
  if (!isLoggedIn()) {
    return { result: undefined, error: 'Not logged in' }
  }

  const res = await api.post<AppSchema.Feedback>('/user/feedback', feedback)
  return res
}

export async function getFeedbacks(status?: AppSchema.Feedback['status'] | 'all') {
  if (!isLoggedIn()) {
    return { result: { feedbacks: [] }, error: undefined }
  }

  const params: any = {}
  if (status && status !== 'all') {
    params.status = status
  }
  const res = await api.get<{ feedbacks: AppSchema.Feedback[] }>('/user/feedback', params)
  return res
}

export async function updateFeedbackStatus(
  feedbackId: string,
  status: AppSchema.Feedback['status']
) {
  if (!isLoggedIn()) {
    return { result: undefined, error: 'Not logged in' }
  }

  const res = await api.post<AppSchema.Feedback>(`/user/feedback/${feedbackId}/status`, { status })
  return res
}

